const translation = {
  nav: {
    home: 'Início',
    categories: 'Categorias',
    articles: 'Guias',
    sheet: 'hoobuy sheet',
    buyNow: 'comprar agora',
    shoppingGuide: 'Guia de Compras',
  },
  hero: {
    badge: 'Atualizado 2026',
    title: 'HoobuySpreadsheet Atualizado 2026',
    subtitle: 'Lista Completa, Guias e Links Verificados',
    description: 'Descubra o HoobuySpreadsheet mais atualizado de 2026, com listas organizadas de produtos da China, incluindo roupas, sneakers, acessórios e eletrônicos.',
    feature1: 'Links atualizados diariamente',
    feature2: 'Produtos testados pela comunidade',
    feature3: 'Comparações de preços reais',
    feature4: 'Guias completos de compra internacional',
    cta: 'Acessar HoobuySpreadsheet Atualizado',
  },
  categories: {
    title: 'Todas as Categorias',
    subtitle: 'Explore nossa seleção completa de produtos organizados',
    viewAll: 'Ver Todos',
  },
  about: {
    tag: 'Por que usar?',
    title: 'Por que usar o HoobuySpreadsheet?',
    description: 'O hoobuyspreadsheet é uma das formas mais eficientes de encontrar produtos baratos e confiáveis da China sem precisar pesquisar manualmente.',
    benefit1: 'Produtos organizados por categoria',
    benefit2: 'Links diretos para compra',
    benefit3: 'Atualizações frequentes',
    benefit4: 'Comparação de qualidade',
    benefit5: 'Economia de até 70%',
    stat1: '14+',
    stat1Label: 'Categorias',
    stat2: '1000+',
    stat2Label: 'Produtos',
    stat3: 'Diariamente',
    stat3Label: 'Atualizado',
    stat4: '70%',
    stat4Label: 'Economia',
  },
  comparison: {
    title: 'HoobuySpreadsheet vs Outros Métodos',
    subtitle: 'Compare e veja por que a planilha hoobuy é a melhor opção',
    col1: 'Método',
    col2: 'Facilidade',
    col3: 'Preço',
    col4: 'Organização',
    col5: 'Confiabilidade',
    row1col1: 'HoobuySpreadsheet',
    row1col2: '⭐⭐⭐⭐⭐',
    row1col3: '⭐⭐⭐⭐',
    row1col4: '⭐⭐⭐⭐⭐',
    row1col5: 'Alta',
    row2col1: 'Pesquisa manual',
    row2col2: '⭐⭐',
    row2col3: '⭐⭐⭐',
    row2col4: '⭐',
    row2col5: 'Média',
    row3col1: 'Marketplaces comuns',
    row3col2: '⭐⭐⭐',
    row3col3: '⭐⭐',
    row3col4: '⭐⭐',
    row3col5: 'Baixa',
  },
  competitors: {
    title: 'Competidores Principais no Google',
    subtitle: 'Análise comparativa de mercado para você entender nossa vantagem',
    comp1Name: 'Pandabuy Spreadsheets',
    comp1Desc: 'Forte em SEO, conteúdo mais antigo, menos organizado',
    comp2Name: 'Sugargoo Guides',
    comp2Desc: 'Conteúdo educativo, pouco foco em listas atualizadas',
    comp3Name: 'Reddit Spreadsheets',
    comp3Desc: 'Alto tráfego orgânico, baixa estrutura SEO',
    advantageTitle: 'Nossa Vantagem Competitiva',
    advantage1: 'Conteúdo estruturado em clusters',
    advantage2: 'Atualização frequente (fresh content)',
    advantage3: 'SEO otimizado por intenção de compra',
    advantage4: 'Tabelas comparativas (rich snippets)',
    advantage5: 'Páginas internas interligadas',
  },
  testimonials: {
    tag: 'Reviews Verificadas',
    title: 'O que dizem nossos usuários',
    subtitle: 'Depoimentos reais de quem já usa o hoobuyspreadsheet',
  },
  cta: {
    title: 'Pronto para encontrar os',
    highlight: 'melhores produtos',
    titleEnd: 'da China?',
    description: 'Acesse agora o hoobuyspreadsheet mais completo e comece a economizar.',
    button: 'buy it now',
  },
  articles: {
    title: 'Guia e Dicas',
    subtitle: 'Artigos exclusivos para maximizar suas compras',
    readMore: 'Leia Mais',
    viewAll: 'Ver todos os artigos',
    viewAllArticles: 'Ver todos os 15 guias de compras',
  },
  footer: {
    brandDesc: 'Sua fonte confiável de listas organizadas de produtos da China. Economize tempo e dinheiro com links verificados e atualizados.',
    categories: 'Categorias',
    social: 'Redes Sociais',
    newsletter: 'Newsletter',
    newsletterDesc: 'Receba as melhores ofertas e atualizações diretamente no seu email.',
    subscribe: 'Inscrever',
    emailPlaceholder: 'Seu melhor email',
    copyright: '© 2026 HoobuySpreadsheet. Todos os direitos reservados.',
    instagram: 'Instagram',
    youtube: 'YouTube',
    facebook: 'Facebook',
  },
};

export default translation;